import {
  renderTaskTableCell,
  TaskTableCellName,
  TaskTableRowVisibility,
} from '../../../Task'
import { ACTIVITIES_TABLE_CELL_NAME_ACTIONS } from '../RequestProfileTabActivities.constants'
import { getRequestProfileTabActivitiesItemActions } from '../RequestProfileTabActivities.utils'
import { RequestProfileTabActivitiesTableActionsCell } from '../RequestProfileTabActivitiesTableActionsCell'
import { RequestProfileTabActivitiesTableManagerCell } from '../RequestProfileTabActivitiesTableManagerCell'

export function renderCell({
  canEditActivities,
  emptyCellClassName,
  hideAutomationsTag,
  item,
  name,
  titleTextClassName,
  onCallAction,
  onChangeVisibility,
  ...restProps
}) {
  function getEmptyCellClassName(value) {
    return value ? undefined : emptyCellClassName
  }

  switch (name) {
    case ACTIVITIES_TABLE_CELL_NAME_ACTIONS:
      return (
        <RequestProfileTabActivitiesTableActionsCell
          {...restProps}
          actions={getRequestProfileTabActivitiesItemActions(
            item,
            canEditActivities
          )}
          item={item}
          name={name}
          onCallAction={onCallAction}
        />
      )

    case TaskTableCellName.VisibleToTenant:
      return (
        <TaskTableRowVisibility
          {...restProps}
          disabled={!canEditActivities}
          item={item}
          name={name}
          onChange={onChangeVisibility}
        />
      )

    case TaskTableCellName.Manager:
      return (
        <RequestProfileTabActivitiesTableManagerCell
          {...restProps}
          className={getEmptyCellClassName(item.manager)}
          item={item}
          name={name}
        />
      )

    case TaskTableCellName.Deadline:
      return renderTaskTableCell({
        ...restProps,
        className: getEmptyCellClassName(item.deadline),
        item,
        name,
      })

    case TaskTableCellName.Priority:
      return renderTaskTableCell({
        ...restProps,
        className: getEmptyCellClassName(item.priority?.value),
        item,
        name,
      })

    case TaskTableCellName.Title:
      return renderTaskTableCell({
        ...restProps,
        hideAutomationsTag,
        item,
        name,
        textClassName: titleTextClassName,
      })

    default:
      return renderTaskTableCell({
        ...restProps,
        hideAutomationsTag,
        item,
        name,
      })
  }
}
